import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ApproveRejectModal from "../../../components/comman/ApproveRejectModal";
import {
  formatAmount,
  HandlePurchaseRequestStatus,
  printData,
} from "../../../utility/CommonFunctions";
import moment from "moment";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { toast } from "react-toastify";
import ViewDocumentModal from "../../Sites/ViewDocumentModal";
import DocumentIcon from "../../../components/Icons/DocumentIcon";
import CreateVoucherModal from "../Voucher/CreateVoucherModal";
import Logs from "../../Logs/Logs";
import ViewIcon from "../../../components/Icons/ViewIcon";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import CommonTable from "../../../components/comman/CommonTable";
import AddTdsModal from "./AddTdsModal";
import AlertModal from "./AlertModel";
import DownloadIcon from "../../../components/Icons/DownloadIcon";
import BgBlurLoader from "../../../components/Loaders/BgBlurLoader";
import { useSelector } from "react-redux";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import MainHeading from "../../../components/comman/MainHeading";
import AddInvoiceDocumentModal from "./AddInvoiceDocumentModal";
import UploadPlusIcon from "../../../components/Icons/UploadPlusIcon";
import MarkAsInProgressModal from "./MarkAsInProgressModal";
import { Spinner } from "reactstrap";

export default function PaymentTicketDetails() {
  let { id } = useParams();
  const navigate = useNavigate();
  const userDetails = useSelector((state) => state.root.userDetails);
  const [dataLoading, setDataLoading] = useState(true);
  const [state, setState] = useState({
    paymentTicketData: {},
    siteBudget: [],
    loading: false,
    IncreaseLoading: false,
  });
  const [pageStates, setPageStates] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    VoucherList: [],
    siteList: [],
    searchQuery: "",
    sortByDate: "",
    year: "",
    siteId: "",
    downloadLoading: false,
    taxableAmount: "",
    markAsInprogressLoading: false,
  });
  // console.log("pageStates?.taxableAmount======>", pageStates?.taxableAmount);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [refreshLogs, setRefreshLogs] = useState(false);
  const [modalType, setModalType] = useState("");
  const [modal, setModal] = useState({
    viewDocModal: false,
    approveRejectModal: false,
    createVoucherModel: false,
    invoiceDocModal: false,
    markAsInProgressModal: false,
  });
  const [showTdsModal, setShowTdsModal] = useState(false);
  const toggleAddTdsModal = (taxableAmount) => {
    setShowTdsModal(!showTdsModal);
  };
  const [alertModal, setAlertModal] = useState(false);
  const toggleAlertModal = () => {
    setAlertModal(!alertModal);
  };
  const toggle = (type) => {
    printData(type);
    setModal((prevModal) => ({
      ...prevModal,
      viewDocModal:
        type === "view" ? !prevModal.viewDocModal : prevModal.viewDocModal,
      approveRejectModal:
        type === "approveReject"
          ? !prevModal.approveRejectModal
          : prevModal.approveRejectModal,
      createVoucherModel:
        type === "voucher"
          ? !prevModal.createVoucherModel
          : prevModal.createVoucherModel,
      invoiceDocModal:
        type === "invoiceDoc"
          ? !prevModal.invoiceDocModal
          : prevModal.invoiceDocModal,
      markAsInProgressModal:
        type === "markAsInProgress"
          ? !prevModal.markAsInProgressModal
          : prevModal.markAsInProgressModal,
    }));
  };

  useEffect(() => {
    GetPaymentTicketDetail();
  }, []);

  const GetPaymentTicketDetail = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.get_payment_ticket_details + `paymentTicketId=${id}`;
    callApi(API, options).then((response) => {
      setDataLoading(false);
      if (response?.status === true) {
        setState((pre) => ({
          ...pre,
          paymentTicketData: response?.data,
        }));
        // printData("PT-Data", response?.data);
      } else {
        toast.error(response?.message);
      }
    });
  };

  useEffect(() => {
    GetVoucherList(pageStates?.currentPage);
  }, [pageStates?.currentPage, pageStates?.searchQuery, pageStates?.pageSize]);

  useEffect(() => {
    const expenseHeads = state?.paymentTicketData?.paymentticketexpenseheads;

    if (Array.isArray(expenseHeads) && expenseHeads.length > 0) {
      let totalTaxableAmount = 0;

      expenseHeads.forEach((exHead) => {
        exHead?.paymentticketitems?.forEach((item) => {
          const quantity = parseFloat(item?.quantity || 0);
          const rate = parseFloat(item?.rate || 0);
          const itemAmount = quantity * rate;
          totalTaxableAmount += itemAmount;
        });
      });

      setPageStates((prev) => ({
        ...prev,
        taxableAmount: totalTaxableAmount,
      }));
    }
  }, [state?.paymentTicketData]);

  const GetVoucherList = () => {
    let options = {
      method: "GET",
    };
    let API =
      apiUrl.get_voucher +
      MainFilterHandler(pageStates) +
      `&paymentTicketId=${id}`;
    setPageStates((prev) => ({
      ...prev,
      tableLoader: true,
      CustomerData: {},
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
      if (response?.status === true) {
        const newData = response?.data?.voucher?.map((item) => ({
          ...item,
          recieverName:
            item?.Transactions?.[0]?.referenceName ||
            item?.Transactions?.[0]?.accountHolderName,
          paymentTicketType: item?.paymentticket?.type,
          transDate: item?.Transactions?.[0]?.transactionDate ? moment(item?.Transactions?.[0]?.transactionDate).format("DD-MM-YYYY") : "--",
          ptNumber: item?.paymentticket?.ticketNumber,
          siteName: item?.paymentticket?.site?.name,
          amount: formatAmount(item?.Transactions?.[0]?.amount),
          createdBy: item?.Transactions?.[0]?.user?.name,
          paymentMethods: item?.Transactions?.[0]?.paymentMethod,
        }));
        setPageStates((prevStates) => ({
          ...prevStates,
          VoucherList: newData,
          count: response?.data?.pageInfo?.total,
          totalPages: response?.data?.pageInfo?.totalPages,
        }));
      }
    });
  };

  const handleDocumentClick = (item) => {
    const docUrl = {
      url: item?.url,
    };
    setSelectedDocument(docUrl);
    toggle("view");
  };

  const handleReqStatus = (status, reason = "") => {
    setIsLoading(true);

    let postData = {
      status: status,
      ...(status === "Rejected" && { rejectReason: reason }),
    };
    const option = {
      method: "POST",
      data: postData,
    };

    callApi(
      apiUrl.update_payment_ticket_status + `?paymentTicketId=${id}`,
      option
    )
      .then((res) => {
        setIsLoading(false);
        if (res?.status === true) {
          toast.success(res?.message);
          GetPaymentTicketDetail();
          setRefreshLogs(true);
        } else {
          toast.error(res?.message);
        }
        toggle("approveReject");
      })
      .catch((err) => {
        console.error(err);
        setIsLoading(false);
      });
  };

  const PageChangeHandler = (PageNo) => {
    if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
      setPageStates((prev) => ({
        ...prev,
        currentPage: PageNo,
      }));
    }
  };

  const handleChangePageSize = (value) => {
    setPageStates((prev) => ({
      ...prev,
      pageSize: value,
      currentPage: 1,
    }));
  };

  const HandleView = (data) => {
    navigate(RoutesLink.voucher_detail + `/${data?.id}`);
  };

  const TableHeading = [
    { value: "voucherNumber", label: "Payment Advisory NO." },
    { value: "ptNumber", label: "PT NO." },
    { value: "recieverName", label: "Reciever Name" },
    { value: "transDate", label: "Date" },
    { value: "siteName", label: "Site" },
    { value: "createdBy", label: "Created By" },
    { value: "paymentTicketType", label: "Type" },
    { value: "paymentMethods", label: "Payment Method" },
    { value: "amount", label: "Amount" },
  ];

  const HandleDownloadPA = async (data) => {
    const submitData = {
      voucherId: [data?.id],
    };
    let options = {
      method: "POST",
      data: submitData,
    };

    const API = apiUrl?.generate_payment_advisory;
    try {
      setPageStates((pre) => ({
        ...pre,
        downloadLoading: true,
      }));
      const response = await callApi(API, options);
      setPageStates((pre) => ({
        ...pre,
        downloadLoading: false,
      }));
      if (response?.status === true && response?.data) {
        const fileUrl = response?.data;
        const fileName = `Payment Advisory.pdf`;

        const fileResponse = await fetch(fileUrl);

        if (!fileResponse.ok) {
          throw new Error("Failed to fetch the file for download");
        }

        const blob = await fileResponse.blob();
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url); // clean up
      } else {
        toast.error(response?.message || "Failed to fetch file URL");
      }
    } catch (err) {
      console.error(err);
      toast.error("Download failed. Please try again.");
    }
  };

  const ActionData = [
    ...(state?.paymentTicketData?.canDownloadPA
      ? [
        {
          label: "download",
          className: "btn btn-link",
          icon: <DownloadIcon />,
          disabled: pageStates?.downloadLoading,
          title: "download",
          clickHandler: HandleDownloadPA,
        },
      ]
      : []),

    ...(state?.paymentTicketData?.canViewPA
      ? [
        {
          label: "view",
          className: "btn btn-link",
          icon: <ViewIcon />,
          title: "view",
          clickHandler: HandleView,
        },
      ]
      : []),
  ];

  const handleMarkAsInprogress = (e) => {
    if (e) e.preventDefault();
    setPageStates((pre) => ({
      ...pre,
      markAsInprogressLoading: true,
    }));
    let options = {
      method: "POST",
    };
    let API = apiUrl.update_only_payment_status + `?paymentTicketId=${id}`;
    callApi(API, options).then((response) => {
      setPageStates((pre) => ({
        ...pre,
        markAsInprogressLoading: false,
      }));
      if (response?.status === true) {
        toast.success(response?.message);
        GetPaymentTicketDetail();
      } else {
        toast.error(response?.message);
      }
    });

  }

  return (
    <>
      {dataLoading && <BgBlurLoader />}
      {pageStates?.downloadLoading && BgBlurLoader()}
      <div className="content container-fluid">
        <MainHeading
          title="Payment Ticket Details"
          showBackButton={true}
        />
        <form action="">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-12">
                      <ul
                        className={
                          dataLoading
                            ? "row list-unstyled mt-4 loading-skeleton"
                            : "row list-unstyled mt-4"
                        }
                      >
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              PT NO. :-
                            </span>
                            {state.paymentTicketData?.ticketNumber
                              ? state.paymentTicketData?.ticketNumber
                              : "--"}
                          </p>
                        </li>
                        {state?.paymentTicketData?.type === "AgainstPO" && (
                          <>
                            <li className="col-12 col-md-6 col-lg-4">
                              <p>
                                <span className="text-muted fs-5 d-block">
                                  PO NO. :-
                                </span>
                                {state.paymentTicketData?.purchase
                                  ?.purchaseNumber
                                  ? state.paymentTicketData?.purchase
                                    ?.purchaseNumber
                                  : "--"}
                              </p>
                            </li>
                            <li className="col-12 col-md-6 col-lg-4">
                              <p>
                                <span className="text-muted fs-5 d-block">
                                  Payment Term :-
                                </span>
                                {state.paymentTicketData?.purchase
                                  ?.paymentTerms || "--"}
                              </p>
                            </li>
                          </>
                        )}
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              GST Type :-
                            </span>
                            {state.paymentTicketData?.gstType || "--"}
                          </p>
                        </li>
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Created By :-
                            </span>
                            {state?.paymentTicketData?.user?.name || "--"}{" "}
                            {state?.paymentTicketData?.user?.designation
                              ?.name && (
                                <span className="text-muted fs-5">
                                  (
                                  {
                                    state?.paymentTicketData?.user?.designation
                                      ?.name
                                  }
                                  )
                                </span>
                              )}
                          </p>
                        </li>

                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Date :-
                            </span>
                            {state.paymentTicketData?.date
                              ? moment(state.paymentTicketData?.date).format(
                                "DD-MM-YYYY"
                              )
                              : "--"}
                          </p>
                        </li>
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Expense Month :-
                            </span>
                            {state.paymentTicketData.expenseMonth ? moment(state.paymentTicketData.expenseMonth, "YYYY-MM").format("MM/YYYY") : "--"}
                          </p>
                        </li>
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Financial Year :-
                            </span>
                            {state?.paymentTicketData?.financialYear || "--"}
                          </p>
                        </li>
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Type :-
                            </span>
                            <span
                              className={
                                state?.paymentTicketData?.type === "AgainstPO"
                                  ? "badge bg-blue-25 fw-normal rounded-pill"
                                  : state?.paymentTicketData?.type === "General"
                                    ? "badge bg-grey-25 fw-normal rounded-pill"
                                    : "badge bg-blue-25 fw-normal rounded-pill"
                              }
                            >
                              {state?.paymentTicketData?.type}
                            </span>
                          </p>
                        </li>
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Status :-
                            </span>
                            {HandlePurchaseRequestStatus(
                              state.paymentTicketData?.status
                            )}
                          </p>
                        </li>
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Site :-
                            </span>
                            {state.paymentTicketData?.site?.name
                              ? state.paymentTicketData?.site?.name
                              : "--"}
                          </p>
                        </li>
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Total Amount :-
                            </span>
                            {formatAmount(
                              state.paymentTicketData?.totalAmount
                            ) || "--"}
                          </p>
                        </li>
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Remaining Amount :-
                            </span>
                            {formatAmount(
                              state.paymentTicketData?.remainingAmount
                            ) || "--"}
                          </p>
                        </li>
                        {state?.paymentTicketData?.rejectReason && (
                          <li className="col-12 col-md-6 col-lg-12">
                            <p>
                              <span className="text-muted fs-5 d-block">
                                Reject Reason :-
                              </span>
                              {state?.paymentTicketData?.rejectReason || "--"}
                            </p>
                          </li>
                        )}
                      </ul>
                    </div>

                    <div className="col-12 ">
                      <h4 className="fs-3 rajdhani-semibold my-4 ">
                        Beneficiary Details
                      </h4>
                      <ul
                        className={
                          dataLoading
                            ? "row list-unstyled mt-4 loading-skeleton"
                            : "row list-unstyled mt-4"
                        }
                      >
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Beneficiary Name :-
                            </span>
                            {state.paymentTicketData?.vendor?.name ||
                              state.paymentTicketData?.purchase?.vendor?.name ||
                              state?.paymentTicketData?.receipientUser?.name ||
                              "--"}
                          </p>
                        </li>
                        {state?.paymentTicketData?.type === "AgainstPO" && (
                          <li className="col-12 col-md-6 col-lg-4">
                            <p>
                              <span className="text-muted fs-5 d-block">
                                Benificiary Firm :-
                              </span>
                              {state.paymentTicketData?.purchase?.vendor
                                ?.firmName || "--"}
                            </p>
                          </li>
                        )}
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Mobile No. :-
                            </span>
                            {state.paymentTicketData?.vendor?.phone ||
                              state.paymentTicketData?.purchase?.vendor
                                ?.phone ||
                              state?.paymentTicketData?.receipientUser?.phone ||
                              "--"}
                          </p>
                        </li>
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Bank Name :-
                            </span>
                            {state?.paymentTicketData?.vendor?.bankName ||
                              state.paymentTicketData?.purchase?.vendor
                                ?.bankName ||
                              state?.paymentTicketData?.receipientUser
                                ?.userdetail?.bankName ||
                              "--"}
                          </p>
                        </li>

                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Account Holder Name :-
                            </span>
                            {state.paymentTicketData?.vendor
                              ?.accountHolderName ||
                              state.paymentTicketData?.purchase?.vendor
                                ?.accountHolderName ||
                              state?.paymentTicketData?.receipientUser
                                ?.userdetail?.accountHolderName ||
                              "--"}
                          </p>
                        </li>
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Account No. :-
                            </span>
                            {state.paymentTicketData?.vendor?.accountNumber ||
                              state.paymentTicketData?.purchase?.vendor
                                ?.accountNumber ||
                              state?.paymentTicketData?.receipientUser
                                ?.userdetail?.accountNumber ||
                              "--"}
                          </p>
                        </li>
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              IFSC Code :-
                            </span>
                            {state.paymentTicketData?.vendor?.ifscCode ||
                              state.paymentTicketData?.purchase?.vendor
                                ?.ifscCode ||
                              state?.paymentTicketData?.receipientUser
                                ?.userdetail?.ifscCode ||
                              "--"}
                          </p>
                        </li>
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Branch Name :-
                            </span>
                            {state.paymentTicketData?.vendor?.branchName ||
                              state.paymentTicketData?.purchase?.vendor
                                ?.branchName ||
                              state?.paymentTicketData?.receipientUser
                                ?.userdetail?.branchAddress ||
                              "--"}
                          </p>
                        </li>
                      </ul>
                    </div>

                    <div className="col-12 ">
                      <div className="d-flex align-items-center justify-content-between border-bottom mb-4">
                        <h4 className="fs-3 rajdhani-semibold my-4 ">
                          Item Details
                        </h4>
                      </div>
                      {state?.paymentTicketData?.type === "AgainstPO" &&
                        state?.paymentTicketData?.paymentticketexpenseheads?.map(
                          (exHead, index) => {
                            let totalAmount = 0;
                            let totalAmountWithGST = 0;
                            return (
                              <div key={exHead.id}>
                                <div className="d-flex align-items-center justify-content-between border-bottom mb-4">
                                  <h4 className="fs-3 rajdhani-semibold my-4 mx-4 text-muted text-decoration-underline">
                                    {exHead?.expensehead?.name}
                                  </h4>
                                </div>
                                <table className="table mt-3">
                                  <thead>
                                    <tr>
                                      <th className="text-start">Item</th>
                                      <th className="text-start">HSN Code</th>
                                      <th className="text-start">Quantity</th>
                                      <th className="text-start">Rate</th>
                                      <th className="text-start">Amount</th>
                                      {state?.paymentTicketData?.gstType ===
                                        "IGST" && <th className="text-start">IGST</th>}
                                      {state?.paymentTicketData?.gstType ===
                                        "CGST + SGST" && (
                                          <>
                                            <th className="text-start">CGST</th>
                                            <th className="text-start">SGST</th>
                                          </>
                                        )}
                                      <th className="text-end">Amount With GST</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {exHead?.paymentticketitems?.map(
                                      (item, i) => {
                                        const amount =
                                          parseFloat(item?.quantity) *
                                          parseFloat(item?.rate);
                                        const gstAmount =
                                          (amount * parseFloat(item?.gst)) /
                                          100;

                                        totalAmount += amount;
                                        totalAmountWithGST += gstAmount;

                                        return (
                                          <tr key={i}>
                                            <td className="desc-wrapper text-start">
                                              {item?.item?.name}
                                            </td>
                                            <td className="desc-wrapper text-start">
                                              {item?.item?.hsnCode || "--"}
                                            </td>
                                            <td className="desc-wrapper text-start">
                                              {item?.quantity}{" "}
                                              {item?.item?.unit}
                                            </td>
                                            <td className="desc-wrapper text-start">
                                              {formatAmount(item?.rate)}
                                            </td>
                                            <td className="desc-wrapper text-start">
                                              {formatAmount(item?.rate * item?.quantity)}
                                            </td>
                                            {state?.paymentTicketData
                                              ?.gstType === "IGST" && (
                                                <td className="desc-wrapper text-start">
                                                  {formatAmount(
                                                    (item?.quantity *
                                                      item?.rate *
                                                      item?.gst) /
                                                    100
                                                  )}{" "}
                                                  ({item?.gst || 0}%)
                                                </td>
                                              )}
                                            {state?.paymentTicketData
                                              ?.gstType === "CGST + SGST" && (
                                                <>
                                                  <td className="desc-wrapper text-start">
                                                    {formatAmount(
                                                      (item?.quantity *
                                                        item?.rate *
                                                        item?.gst) /
                                                      2 /
                                                      100
                                                    )}{" "}
                                                    ({item?.gst / 2 || 0}%)
                                                  </td>
                                                  <td className="desc-wrapper text-start">
                                                    {formatAmount(
                                                      (item?.quantity *
                                                        item?.rate *
                                                        item?.gst) /
                                                      2 /
                                                      100
                                                    )}{" "}
                                                    ({item?.gst / 2 || 0}%)
                                                  </td>
                                                </>
                                              )}
                                            <td className="desc-wrapper text-end">
                                              {formatAmount(
                                                item?.taxableAmount
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      }
                                    )}
                                  </tbody>
                                  <tfoot>
                                    <tr className="fw-bold">
                                      <td className="fw-bold text-start">Total</td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td className="text-start">{formatAmount(totalAmount)}</td>
                                      {state?.paymentTicketData?.gstType ===
                                        "IGST" && (
                                          <td className="text-start">
                                            {formatAmount(totalAmountWithGST)}
                                          </td>
                                        )}
                                      {state?.paymentTicketData?.gstType ===
                                        "CGST + SGST" && (
                                          <>
                                            <td className="text-start">
                                              {formatAmount(
                                                totalAmountWithGST / 2
                                              )}
                                            </td>
                                            <td className="text-start">
                                              {formatAmount(
                                                totalAmountWithGST / 2
                                              )}
                                            </td>
                                          </>
                                        )}
                                      <td className="text-end">
                                        {formatAmount(exHead?.taxableAmount)}
                                      </td>
                                    </tr>
                                  </tfoot>
                                </table>
                              </div>
                            );
                          }
                        )}

                      {(state?.paymentTicketData?.type === "General" ||
                        state?.paymentTicketData?.type === "Reimbursement") &&
                        state?.paymentTicketData?.paymentticketexpenseheads?.map(
                          (exHead, index) => {
                            let totalAmount = 0;
                            let totalAmountWithGST = 0;
                            return (
                              <div key={exHead.id}>
                                <div className="d-flex align-items-center justify-content-between border-bottom mb-4">
                                  <h4 className="fs-3 rajdhani-semibold my-4 mx-4 text-muted text-decoration-underline">
                                    {exHead?.expensehead?.name}
                                  </h4>
                                </div>
                                <table className="table mt-3">
                                  <thead>
                                    <tr>
                                      <th className="text-start">Item</th>
                                      <th className="text-start">Quantity</th>
                                      <th className="text-start">Rate</th>
                                      <th className="text-start">Amount</th>
                                      {state?.paymentTicketData?.gstType ===
                                        "IGST" && <th className="text-start">IGST</th>}
                                      {state?.paymentTicketData?.gstType ===
                                        "CGST + SGST" && (
                                          <>
                                            <th className="text-start">CGST</th>
                                            <th className="text-start">SGST</th>
                                          </>
                                        )}
                                      <th className="text-end">Amount With GST</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {exHead?.paymentticketitems?.map(
                                      (item, i) => {
                                        const amount =
                                          parseFloat(item?.quantity) *
                                          parseFloat(item?.rate);
                                        const gstAmount =
                                          (amount * parseFloat(item?.gst)) /
                                          100;

                                        totalAmount += amount;
                                        totalAmountWithGST += gstAmount;

                                        return (
                                          <tr key={i}>
                                            <td className="desc-wrapper text-start">
                                              {item?.item?.name}
                                            </td>
                                            <td className="desc-wrapper text-start">
                                              {item?.quantity}{" "}
                                              {item?.item?.unit}
                                            </td>
                                            <td className="desc-wrapper text-start">
                                              {formatAmount(item?.rate)}
                                            </td>
                                            <td className="desc-wrapper text-start">
                                              {formatAmount(item?.rate * item?.quantity)}
                                            </td>

                                            {state?.paymentTicketData
                                              ?.gstType === "IGST" && (
                                                <td className="desc-wrapper text-start">
                                                  {formatAmount(
                                                    (item?.quantity *
                                                      item?.rate *
                                                      item?.gst) /
                                                    100
                                                  )}{" "}
                                                  ({item?.gst || 0}%)
                                                </td>
                                              )}
                                            {state?.paymentTicketData
                                              ?.gstType === "CGST + SGST" && (
                                                <>
                                                  <td className="desc-wrapper text-start">
                                                    {formatAmount(
                                                      (item?.quantity *
                                                        item?.rate *
                                                        item?.gst) /
                                                      2 /
                                                      100
                                                    )}{" "}
                                                    ({item?.gst / 2 || 0}%)
                                                  </td>
                                                  <td className="desc-wrapper text-start">
                                                    {formatAmount(
                                                      (item?.quantity *
                                                        item?.rate *
                                                        item?.gst) /
                                                      2 /
                                                      100
                                                    )}{" "}
                                                    ({item?.gst / 2 || 0}%)
                                                  </td>
                                                </>
                                              )}

                                            <td className="desc-wrapper text-end">
                                              {formatAmount(
                                                item?.taxableAmount
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      }
                                    )}
                                  </tbody>
                                  <tfoot>
                                    <tr className="fw-bold">
                                      <td className="fw-bold text-start">Total</td>
                                      <td></td>
                                      <td></td>
                                      <td className="text-start">{formatAmount(totalAmount)}</td>
                                      {state?.paymentTicketData?.gstType ===
                                        "IGST" && (
                                          <td className="text-start">
                                            {formatAmount(totalAmountWithGST)}
                                          </td>
                                        )}
                                      {state?.paymentTicketData?.gstType ===
                                        "CGST + SGST" && (
                                          <>
                                            <td className="text-start">
                                              {formatAmount(
                                                totalAmountWithGST / 2
                                              )}
                                            </td>
                                            <td className="text-start">
                                              {formatAmount(
                                                totalAmountWithGST / 2
                                              )}
                                            </td>
                                          </>
                                        )}
                                      <td className="text-end">
                                        {formatAmount(exHead?.taxableAmount)}
                                      </td>
                                    </tr>
                                  </tfoot>
                                </table>
                              </div>
                            );
                          }
                        )}

                      <div className="d-flex justify-content-end mt-5 mb-3">
                        <div className="px-5 py-3 bg-white text-end">
                          <h4 className="fs-4 fw-bold rajdhani-semibold mb-0">
                            Grand Total:&nbsp; {""}
                            <span className="text-primary fw-bold">
                              {formatAmount(
                                state?.paymentTicketData?.totalAmount
                              )}
                            </span>
                          </h4>
                        </div>
                      </div>
                      {state?.paymentTicketData?.type !== "Reimbursement" && (
                        <>
                          <table className="table mt-3">
                            <tbody>
                              <tr>
                                {[...Array(18)].map((_, idx) => (
                                  <td key={idx}></td>
                                ))}

                                <td className="fw-bold">
                                  TDS(
                                  {+state?.paymentTicketData?.tdsPercentage ||
                                    0}
                                  %)
                                </td>

                                <td>
                                  {formatAmount(
                                    +state?.paymentTicketData?.tdsAmount || 0
                                  )}
                                </td>

                                <td>
                                  {(state?.paymentTicketData?.canInsertTDS ||
                                    state?.paymentTicketData?.canUpdateTDS) && (
                                      <button
                                        className="btn btn-sm btn-outline-primary p-2"
                                        type="button"
                                        onClick={toggleAddTdsModal}
                                      >
                                        {state?.paymentTicketData?.canInsertTDS &&
                                          "Add TDS"}
                                        {state?.paymentTicketData?.canUpdateTDS &&
                                          "Edit TDS"}
                                      </button>
                                    )}
                                </td>
                              </tr>
                            </tbody>
                          </table>

                          <div className="d-flex justify-content-end mt-5 mb-3">
                            <div className="px-5 py-3 bg-white shadow-sm border rounded text-end">
                              <h4 className="fs-3 fw-bold rajdhani-semibold mb-0">
                                Gross Amount:&nbsp; {""}
                                <span className="text-success fw-bold">
                                  {formatAmount(
                                    state?.paymentTicketData?.grossAmount
                                  )}
                                </span>
                              </h4>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>


        {!dataLoading && (state?.paymentTicketData?.canChangeStatus) && (
          <div className="d-flex align-items-center justify-content-end gap-3 mb-3">
            <button
              className="btn btn-danger px-5"
              type="button"
              onClick={() => {
                setModalType("reject");
                toggle("approveReject");
              }}
            >
              Reject
            </button>
            <button
              className="btn btn-success px-5"
              type="button"
              onClick={() => {
                setModalType("approve");
                toggle("approveReject");
              }}
            >
              Approve
            </button>
          </div>
        )}

        {state?.paymentTicketData?.canCreateVoucher &&
          userDetails?.designation?.canCreate?.includes("voucher") && (
            <div className="d-flex gap-2 justify-content-end">
              {(state?.paymentTicketData?.status === "Finance Approved" ||
                state?.paymentTicketData?.status === "Director Approved")
                && (state?.paymentTicketData?.paymentStatus === "pending" || state?.paymentTicketData?.paymentStatus === "In Progress") && (
                  <button
                    className="btn btn-outline-primary px-5"
                    type="button"
                    disabled={pageStates?.markAsInprogressLoading}
                    onClick={() => toggle("markAsInProgress")}
                  >
                    {pageStates?.markAsInprogressLoading ? <Spinner /> : state?.paymentTicketData?.paymentStatus === "pending" ? "Mark as inprogress" : "Mark as pending"}
                  </button>
                )}
              <button
                className="btn btn-primary px-5"
                type="button"
                onClick={() => {
                  if (
                    state?.paymentTicketData?.canInsertTDS &&
                    state?.paymentTicketData?.type !== "Reimbursement"
                  ) {
                    toggleAlertModal();
                  } else {
                    toggle("voucher");
                  }
                }}
              >
                Create Payment Advisory
              </button>
            </div>
          )}

        {(state?.paymentTicketData?.status?.includes("Approved") ||
          state?.paymentTicketData?.status?.includes("Completed") ||
          state?.paymentTicketData?.status?.includes("Director Created") ||
          state?.paymentTicketData?.status?.includes("Finance Created")) && (
            <>
              {" "}
              <h4 className="mb-4">Payment Advisories</h4>
              <div className="card px-2 pb-2">
                <CommonTable
                  TableHeading={TableHeading}
                  TableData={pageStates?.VoucherList}
                  ActionData={ActionData}
                  currentPage={pageStates?.currentPage}
                  PageChangeHandler={PageChangeHandler}
                  isLoading={pageStates?.tableLoader}
                  totalPages={pageStates?.totalPages}
                  count={pageStates?.count}
                  handleChangePageSize={handleChangePageSize}
                  pageSize={pageStates?.pageSize}
                />
              </div>
            </>
          )}

        {state?.paymentTicketData?.isInvoice !== true && (
          <div className="d-flex justify-content-between align-items-center p-2 mb-4 bg-light border border-warning rounded-3">
            <div className="d-flex align-items-center gap-2">
              <i className="fas fa-exclamation-triangle text-warning"></i>
              <span className="text-dark fs-5 fw-medium">
                Invoice document is missing. Please upload the invoice.
              </span>
            </div>

            <button
              className="btn btn-primary d-flex align-items-center gap-2"
              onClick={() => toggle("invoiceDoc")}
            >
              <i className="fas fa-upload"></i>
              Upload Invoice
            </button>
          </div>
        )}

        <div className="row">
          <div className="col-12">
            <div className="card manage-user-list">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between border-bottom mb-3">
                  <h4 className="d-flex align-items-center mb-4">Documents</h4>
                </div>
                <ul className="row list-unstyled gap-3">
                  {state?.paymentTicketData?.documents?.length > 0 ? (
                    state?.paymentTicketData?.documents?.map((doc, index) => {
                      return (
                        <li key={index} className="col-12">
                          <div
                            className="text-muted fs-5 d-flex align-items-center justify-content-between text-decoration-none w-100"
                            onClick={() => handleDocumentClick(doc)}
                            role="button"
                          >
                            <span className="d-flex align-items-center gap-2">
                              <DocumentIcon />
                              {doc?.name || "Document"}
                            </span>
                            <span className="fs-6">
                              {doc?.updatedAt ? moment(doc?.updatedAt).format("DD MMM YYYY | h:mm a") : ""}
                            </span>
                          </div>
                        </li>
                      );
                    })
                  ) : (
                    <div>No Document Found</div>
                  )}
                </ul>
              </div>
            </div>
          </div>

        </div>

        <div className="col-12">
          <div className="form-group mb-3">
            <label htmlFor="totalLeavePerMonth" className="form-label">
              Description
            </label>
            <CKEditor
              editor={ClassicEditor}
              data={state?.paymentTicketData?.description || "No Desctiption..."}
              disabled={true}
              config={{
                toolbar: [],
                readOnly: true,
                image: {
                  toolbar: [
                    "imageStyle:alignLeft",
                    "imageStyle:alignCenter",
                    "imageStyle:alignRight",
                    "|",
                    "imageTextAlternative",
                  ],
                },
              }}
            />
          </div>
        </div>

        <Logs
          type={"paymentTicket"}
          id={id}
          refreshLogs={refreshLogs}
          setRefreshLogs={setRefreshLogs}
        />
      </div>

      <ApproveRejectModal
        modal={modal.approveRejectModal}
        toggle={() => toggle("approveReject")}
        submitHandler={(reason) =>
          handleReqStatus(
            modalType === "reject" ? "Rejected" : "Approved",
            reason
          )
        }
        isLoading={isLoading}
        actionType={modalType}
      />
      <ViewDocumentModal
        modal={modal.viewDocModal}
        toggle={() => toggle("view")}
        selectedDocument={selectedDocument}
      />
      <AddInvoiceDocumentModal
        modal={modal.invoiceDocModal}
        toggle={() => toggle("invoiceDoc")}
        modalData={state?.paymentTicketData}
        GetPaymentTicketDetail={GetPaymentTicketDetail}
      />
      <AddTdsModal
        modal={showTdsModal}
        toggle={toggleAddTdsModal}
        modalData={state?.paymentTicketData}
        taxableAmount={pageStates?.taxableAmount}
        GetPaymentTicketDetail={GetPaymentTicketDetail}
      />
      <CreateVoucherModal
        isOpen={modal.createVoucherModel}
        toggle={() => toggle("voucher")}
        EditData={null}
        paymentTicketDetails={state?.paymentTicketData}
        GetPaymentTicketDetail={GetPaymentTicketDetail}
        GetVoucherList={GetVoucherList}
        from="paymentTicket"
      />
      <AlertModal
        modal={alertModal}
        toggle={toggleAlertModal}
        submitHandler={() => toggle("voucher")}
      />
      <MarkAsInProgressModal
        modal={modal.markAsInProgressModal}
        toggle={() => toggle("markAsInProgress")}
        submitHandler={handleMarkAsInprogress}
        isPending={state?.paymentTicketData?.paymentStatus === "pending"}
      />
    </>
  );
}
